import monitor from "csi/monitor/_base";
import { C8Node } from "csi/typings";

/** determine if PDF service succeed */
export function pdfRequestIsSuccessful(node: C8Node): boolean {
	return node.Status === "Succeeded";
}

/** wait for PDF service succeed */
export async function waitForPDFRequestSucceed(pdfRequest: C8Node, interval: number, timeout: number): Promise<C8Node> {
	return monitor.waitForNodeCondition(pdfRequest, (node) => pdfRequestIsSuccessful(node), interval, timeout);
}